import "./chart.css";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function Chart({ title, data, dataKey, grid }) {
  return (
    <div className="chart">
      <h3 className="charttitle">{title}</h3>
      <ResponsiveContainer width="100%" aspect={5 / 1.5}>
        <LineChart data={data}>
          <XAxis dataKey="month" stroke="#000907" />

          <Line type="monotone" dataKey={dataKey} stroke="#098b15" />
          <Tooltip />
          {grid && <CartesianGrid stroke="#f1c7d2" strokeDasharray="5 5" />}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
